export const EmbeddedVideo = __props => null;
export default EmbeddedVideo;